import { getSettingsContactsApi as generatedGetSettingsContactsApi } from '../generated/settingsContacts/getSettingsContacts';

const getSettingsContactsApi = generatedGetSettingsContactsApi.enhanceEndpoints({
  endpoints: {
    getSettingsContacts: {
      providesTags: ['SettingsContacts'],
    },
  },
});

export const { useGetSettingsContactsQuery } = getSettingsContactsApi;
